var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "mb-3",
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1), _c('span', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.back')))])], 1), _c('v-toolbar-title', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.forms.index_title')) + "\n      ")]), _c('v-spacer')], 1)], 1), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l(this.formTemplates, function (form, index) {
    return _c('v-list-tile', {
      key: 'form' + index,
      attrs: {
        "avatar": "",
        "to": {
          path: '/form/' + form.slug
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("poll")])], 1), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(form.name)
      }
    }), form.description ? _c('v-list-tile-sub-title') : _vm._e()], 1)], 1);
  })], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }